import * as React from 'react';
import { MeteredUsageItem, ProcessorParameterType } from '@journeyapps-platform/types-charging-station';
import { styled } from '../../../../../theme';
import { MeterWidget } from './MeterWidget';
import { DateTime } from 'luxon';
import { formatCurrency } from '../../../../../utils/currency';

export interface MeteredWidgetProps {
  item: MeteredUsageItem;
  billing_enabled: boolean;
  className?: any;
}

const formatter2 = new Intl.NumberFormat('en-US');

export const MeteredWidget: React.FC<MeteredWidgetProps> = (props) => {
  let amount = props.item.usage;
  let tiers = props.item.tiers;
  let unit = '';

  const is_bytes = props.item.type === ProcessorParameterType.METERED_BYTES;

  if (is_bytes) {
    unit = 'GB';
    amount = parseFloat((props.item.usage / (1000 * 1000 * 1000)).toFixed(2));
    tiers = tiers.map((t) => {
      if (t.max === -1) {
        return t;
      }
      return {
        ...t,
        max: t.max! / (1000 * 1000 * 1000)
      };
    });
  }

  return (
    <S.Container className={props.className}>
      <S.Top>
        <S.Label>{props.item.label}</S.Label>
        {props.item.last_reported_at ? (
          <S.LastUpdated>Last updated: {DateTime.fromISO(props.item.last_reported_at).toRelative()}</S.LastUpdated>
        ) : null}
      </S.Top>
      <S.Desc>{props.item.desc}</S.Desc>
      {props.billing_enabled ? (
        <S.Pills>
          {props.item.tiers.map((t, index) => {
            let costValue = t.cost / 100;
            if (is_bytes) {
              costValue *= 1000 * 1000 * 1000;
            }
            let cost = formatCurrency(costValue);
            let text = `${cost} per unit`;
            if (is_bytes) {
              text = `${cost} per GB`;
            }

            if (t.max !== -1) {
              let max: string = `${formatter2.format(t.max!)}`;
              if (is_bytes) {
                max = `${formatter2.format(t.max! / (1000 * 1000 * 1000))} GB`;
              }
              text = `${text} up to ${max}`;
            }

            return (
              <S.Pill key={index}>
                Tier {index + 1}: {text}
              </S.Pill>
            );
          })}
        </S.Pills>
      ) : null}
      <S.Meter
        unit={unit}
        amount={amount}
        tiers={tiers.map((t) => {
          return {
            max: t.max || -1
          };
        })}
      />
    </S.Container>
  );
};
namespace S {
  export const Top = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  `;

  export const LastUpdated = styled.div`
    color: white;
    opacity: 0.3;
    font-size: 12px;
    padding: 5px;
  `;

  export const Pill = styled.div`
    background: rgba(255, 255, 255, 0.05);
    color: white;
    padding: 4px 10px;
    border-radius: 15px;
    font-size: 12px;
  `;

  export const Pills = styled.div`
    display: flex;
    column-gap: 5px;
    margin-top: 10px;
  `;

  export const Meter = styled(MeterWidget)`
    margin-top: 10px;
  `;

  export const Label = styled.div`
    font-size: 18px;
    color: ${(p) => p.theme.text.primary};
    margin-bottom: 5px;
  `;

  export const Desc = styled.div`
    font-size: 12px;
    opacity: 0.5;
    color: ${(p) => p.theme.text.primary};
    max-width: 900px;
  `;

  export const Container = styled.div`
    background: rgba(255, 255, 255, 0.03);
    padding: 15px 15px;
    border-radius: 10px;
  `;
}
